type DnsRecordLike = {
  rrType?: string;
  rdata?: string;
};

const RESOLVES_TO_RR_TYPES = new Set(['A', 'AAAA', 'CNAME']);

export function firstHostname({
  hostnames,
}: {
  hostnames: string[] | undefined;
}): string | null {
  return hostnames?.[0] ?? null;
}

export function domainResolvesTo({
  dnsRecords,
}: {
  dnsRecords: DnsRecordLike[] | undefined;
}): string | null {
  if (!dnsRecords || dnsRecords.length === 0) {
    return null;
  }

  const values = dnsRecords
    .filter((record) => RESOLVES_TO_RR_TYPES.has(record.rrType ?? ''))
    .map((record) => record.rdata ?? '')
    .filter((rdata) => rdata.length > 0);

  return values[0] ?? null;
}

export function softwareDetectionSource({
  observations,
}: {
  observations: Array<{ sourceType?: string | null }> | undefined;
}): string | null {
  return observations?.[0]?.sourceType ?? null;
}

export function readStringField({
  raw,
  key,
}: {
  raw: Record<string, unknown>;
  key: string;
}): string | null {
  const value = raw[key];

  return typeof value === 'string' && value.length > 0 ? value : null;
}

export function readNumberField({
  raw,
  key,
}: {
  raw: Record<string, unknown>;
  key: string;
}): number | undefined {
  const value = raw[key];

  return typeof value === 'number' ? value : undefined;
}

export function readBooleanField({
  raw,
  key,
}: {
  raw: Record<string, unknown>;
  key: string;
}): boolean {
  return raw[key] === true;
}
